import { goToMainRoute } from "project-config/utils/env";
import { Modal } from ".";

type ModalType = "sub-account-modify-password" | "";

export class CreateInterceptModal {
  static eventMap = new Map<string, () => void>();
  static runningStack: string[] = [];
  static type: ModalType = "";
  static handle: () => void | Promise<void> = () => {};
  static createModal({
    title,
    content,
  }: {
    title: string;
    content: React.ReactNode;
  }) {
    async function redirect() {
      await CreateInterceptModal.handle();
      goToMainRoute();
      CreateInterceptModal.recycle();
    }
    Modal.confirm({
      title,
      children: content,
      onOk: () => redirect(),
      onClose: () => redirect(),
      open: true,
    });
  }
  static emit({
    type,
    title,
    content,
  }: {
    type: ModalType;
    title: string;
    content: React.ReactNode;
  }) {
    this.type = type;
    this.eventMap.set(type, () => this.createModal({ title, content }));
    this.run();
  }
  static run() {
    if (this.runningStack.indexOf(this.type) <= -1) {
      this.eventMap.get(this.type)?.();
      this.runningStack.push(this.type);
    }
  }
  static recycle() {
    this.eventMap.has(this.type) && this.eventMap.delete(this.type);
    this.runningStack.pop();
    this.type = "";
  }
}
